module.exports = __webpack_public_path__ + "static/portfolio-about-3-a16855a7c644df75956dfe647edc5fe8.jpg";